import React, { FunctionComponent, ReactNode } from "react";
import { styled } from "@mui/material/styles";
import Box, { BoxProps } from "@mui/material/Box";
import Text, { TextProps } from "../text/Text";
const PREFIX = "Placeholder";

const classes = {
	root: `${PREFIX}root`,
};

const StyledBox = styled(Box)(({
	theme: { spacing },
}) => ({
	[`&.${classes.root}`]: {
		alignItems: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		padding: spacing(4),
		width: "100%",
	},
}));

export interface PlaceholderProps extends Omit<BoxProps, "alignItems" | "children"> {
	/** child components of the placeholder */
	children?: {
		actions?: ReactNode;
		image?: ReactNode;
	};

	/** title text properties */
	titleProps: Omit<TextProps, "size">;

	/** margin to apply to subtitle to force more wrapping */
	subtitleMargin?: number;

	/** subtitle text properties */
	subtitleProps?: Omit<TextProps, "size">;

	/** width to apply to subtitle to force more wrapping */
	subtitleWidth?: number;
}

const Placeholder: FunctionComponent<PlaceholderProps> = (props) => {
	const {
		children,
		titleProps,
		subtitleMargin,
		subtitleProps,
		subtitleWidth,
		...otherProps
	} = props;


	const actions = children?.actions;
	const image = children?.image;

	return (
		<StyledBox className={classes.root} {...otherProps}>
			{image && (
				<Box
					display="flex"
					justifyContent="center"
				>
					{image}
				</Box>
			)}
			<Box
				color="black.300"
				fontSize={24}
				mt={image ? 2 : 0}
				textAlign="center"
			>
				<Text size={24} {...titleProps} />
			</Box>
			{subtitleProps && (
				<Box
					color="grey.900"
					mt={1}
					mx={subtitleMargin || 0}
					textAlign="center"
					width={subtitleWidth}
				>
					<Text {...subtitleProps} />
				</Box>
			)}
			{actions && (
				<Box
					display="flex"
					justifyContent="center"
					mt={2}
					width={1}
				>
					{actions}
				</Box>
			)}
		</StyledBox>
	);
};

export default Placeholder;